import React from 'react';
import { supportedLanguages, languageNames } from '../translations';

const LanguageSwitcher: React.FC = () => {
  return (
    <>
      {/* Hidden language links for SEO/crawlers - completely invisible */}
      <div style={{ display: 'none' }} aria-hidden="true">
        {supportedLanguages.map((lang) => (
          <a
            key={lang}
            href={`/${lang}/`}
            rel="alternate"
            hrefLang={lang}
            lang={lang}
          >
            {languageNames[lang]}
          </a>
        ))}
      </div>
    </>
  );
};

export default LanguageSwitcher;
